
const GlobalConfig = {
    defaultDays: 7,
    parentrollstartdate:180,
    DecimalPointsReamWeight:10,
    DecimalPointsBundleWeight:10
  };
  export default GlobalConfig;
  